// import $ from 'jquery';
// window.$ = $;

import jquery from 'jquery'

window.$ = window.jQuery = jquery